var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/ListExtension.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-grid.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/fonts/fonts.js";
import "@adornis/forms/x-checkbox.js";
import "@adornis/forms/x-input.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";
import { BaseList } from "../../db/extensions/BaseList.js";
import { BaseText } from "../../db/extensions/text/BaseText.js";
import "../components/x-buildify-color-picker.js";
import "../components/x-buildify-permission-selection.js";
import "../components/x-buildify-spacing-picker.js";
import { ExtensionBoilerplate } from "./ContentExtensionBoilerplate.js";
var ListExtension = ({
  textExtension,
  iconExtension
}) => ({
  class: BaseList,
  toolbar: { icon: "list", text: { default: "Liste" } },
  render(instance, { defaultValues, isSubelement, dropzoneBefore, dropzoneAfter }) {
    return xComponents(html`
      <x-list-extension
        .textExtension=${textExtension}
        .iconExtension=${iconExtension}
        .content=${instance}
        .defaultValues=${defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-list-extension>
    `);
  },
  editor({ content, contentController, controllerBaseKeyPath, host }) {
    return html`
      <x-flex space="md">
        <x-checkbox
          label="Einfache Aufzählung"
          ${contentController.field("isHyphen")}
          @value-picked=${() => host.requestUpdate()}
        ></x-checkbox>
        ${!content.isHyphen ? html`
              ${iconExtension.editor?.({
      content: content.icon,
      contentController,
      controllerBaseKeyPath: ["icon"],
      host
    })}
            ` : nothing}
        <x-hr></x-hr>
        ${repeat(
      content.items ?? [],
      (item) => item._id,
      (item, i) => html`
            <x-flex horizontal crossaxis-center space="sm">
              <x-text> ${i + 1}. </x-text>
              ${textExtension.editor?.({ content: item, contentController, controllerBaseKeyPath: ["items", i], host })}
              <x-button
                mode="icon"
                icon="delete"
                tone="error"
                @click=${() => {
        content.items.splice(i, 1);
        host.requestUpdate();
      }}
              ></x-button>
            </x-flex>
          `
    )}
        <x-button
          mode="outline"
          icon="add"
          @click=${() => {
      if (!content.items)
        content.items = [];
      content.items.push(new BaseText({}));
      host.requestUpdate();
    }}
        >
          Zeile hinzufügen
        </x-button>
      </x-flex>
    `;
  },
  group: "Schriften"
});
var XListExtension = class extends ExtensionBoilerplate {
  _content(content) {
    const listSymbol = this._listSymbol(content);
    return html`
      <x-grid columns="max-content 1fr" ${css({ gap: "20px 16px" })}>
        ${repeat(
      content.items,
      (item) => item._id,
      (textContent) => html`
            <!-- list symbol -->
            ${listSymbol}

            <!-- text -->
            <x-flex
              ${css({
        height: "min-content"
      })}
            >
              ${this.TextExtension.render(textContent, { isSubelement: true })}
            </x-flex>
          `
    )}
      </x-grid>
    `;
  }
  _listSymbol(content) {
    if (content.isHyphen)
      return html` <x-text> - </x-text> `;
    return html`
      <x-flex ${css({ position: "relative", height: "100%" })} start crossaxis-center>
        ${this.IconExtension.render(content.icon, {
      isSubelement: true,
      defaultValues: {
        icon: { global: this.icon },
        size: { global: "16px" },
        color: { global: "#333" }
      }
    })}
      </x-flex>
    `;
  }
  get TextExtension() {
    if (!this.textExtension)
      throw new Error("text extension in list is mandatory");
    return this.textExtension;
  }
  get IconExtension() {
    if (!this.iconExtension)
      throw new Error("icon extension in list is mandatory");
    return this.iconExtension;
  }
  get icon() {
    return "arrow_right_alt";
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          width: "100%"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XListExtension.prototype, "textExtension", 2);
__decorateClass([
  property({ attribute: false })
], XListExtension.prototype, "iconExtension", 2);
XListExtension = __decorateClass([
  customElement("x-list-extension")
], XListExtension);
export {
  ListExtension,
  XListExtension
};
